import React from 'react';

export class AnalyticsSimpleTileCollapser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collapsed: this.getIsCollapsedFlag(props)
        };
    }

    componentDidUpdate(prevProps) {
        const prevCollapsedState = this.getIsCollapsedFlag(prevProps);
        const curCollapsedState = this.getIsCollapsedFlag(this.props);
        if (prevCollapsedState !== curCollapsedState) {
            this.setState({ collapsed: curCollapsedState });
        }
    }

    getIsCollapsedFlag = (props) => {
        return (props.settings?.collapsedState || {})[props.sectionName];
    }

    collapse = () => {
        const { report, sectionName, toggleReportSection, project } = this.props;
        const { collapsed } = this.state;

        toggleReportSection({
            project,
            report,
            sectionName,
            collapsed: !collapsed
        });
    }

    render() {
        const { mode, children } = this.props;
        const { collapsed } = this.state;
        const collapseClass = collapsed ? 'analytics-simple-tile-collapser__expand' : 'analytics-simple-tile-collapser__collapse';

        return <div className="analytics-simple-tile-collapser">
            <div
                className="analytics-simple-tile-collapser__content"
                onClick={!mode ? this.collapse : undefined}>
                {!mode && <i className={`icon icon-alan-chevron-fat ${collapseClass}`} />}
                <div>
                    {children}
                </div>
            </div>
        </div>;
    }
}